












import { Component, Mixins, Prop } from "vue-property-decorator";
import { MovableTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { MovableTextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import MovableTextBoxObject from "../../../document/editor/objects/MovableTextBoxObject.vue";
import InputMethodSelector from "./InputMethodSelector.vue";
import Enumerable from "linq";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class MovableTextBoxInputMethodSelector extends Mixins() {
  @Prop()
  source: MovableTextBoxObject;

  @Prop({ default: true })
  isUnselectionEnable: boolean;

  get optionSet(): MovableTextBoxInputMethodKinds[] {
    if (this.source.isEditDisabledByRuleSet) {
      return [];
    }
    const kinds = this.optionSets[this.source.inputMethodOptionKind];
    return this.source.isFreeInputable
      ? kinds
      : Enumerable.from(kinds).where(k => k !== MovableTextBoxInputMethodKinds.FreeInput).toArray();
  }

  get unselection(): MovableTextBoxInputMethodKinds {
    return this.isUnselectionEnable
      ? this.unselectionSets[this.source.inputMethodOptionKind]
      : null;
  }

  displayTexts: { key: MovableTextBoxInputMethodKinds, text: string }[] = [
    { key: MovableTextBoxInputMethodKinds.None, text: "入力不可" },
    { key: MovableTextBoxInputMethodKinds.FreeInput, text: "フリー入力" },
    { key: MovableTextBoxInputMethodKinds.MKSTemplate, text: "MKSテンプレート" },
    { key: MovableTextBoxInputMethodKinds.DynamicTemplate, text: "ダイナミックテンプレート" },
  ];

  private optionSets: { [key in MovableTextBoxInputMethodOptionKinds]: MovableTextBoxInputMethodKinds[] } = {
    Normal: [], // 常にフリー入力なので切り替えない
    MKSTemplate: [ MovableTextBoxInputMethodKinds.FreeInput, MovableTextBoxInputMethodKinds.MKSTemplate ],
    DynamicTemplate: [ MovableTextBoxInputMethodKinds.FreeInput, MovableTextBoxInputMethodKinds.DynamicTemplate ],
  };

  private unselectionSets: { [key in MovableTextBoxInputMethodOptionKinds]: MovableTextBoxInputMethodKinds } = {
    Normal: null,
    MKSTemplate: null,
    DynamicTemplate: null,
  };
}
